import classNames from "classnames";
import "./index.scss";

const Main = ({ children, fullHeight = false }) => (
  <main className={classNames("pdl_component_main", { "h-100": fullHeight })}>
    {children}
  </main>
);

export default Main;
